import { render, staticRenderFns } from "./KpiCard.vue?vue&type=template&id=4c145d04&lang=pug&"
import script from "./KpiCard.vue?vue&type=script&lang=js&"
export * from "./KpiCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports